"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnexpectedError = void 0;
var _react = _interopRequireDefault(require("react"));
var _useTranslation2 = require("../../hooks/useTranslation/useTranslation");
var _Error = require("../error/Error");
var UnexpectedError = function UnexpectedError() {
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Error.ErrorComponent, {
    errorMessage: t('errors.unexpectedError')
  });
};
exports.UnexpectedError = UnexpectedError;